module.exports = __webpack_public_path__ + "static/media/33@2x.3b282a60.png";